import { render, staticRenderFns } from "./ListFacility.vue?vue&type=template&id=2fe22878&scoped=true&"
import script from "./ListFacility.vue?vue&type=script&lang=js&"
export * from "./ListFacility.vue?vue&type=script&lang=js&"
import style0 from "./ListFacility.vue?vue&type=style&index=0&id=2fe22878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe22878",
  null
  
)

export default component.exports